<template>
    <div>
<!--        <div class="initiateBox">-->
<!--            <div class="contract">-->
<!--                <div class="initiate" @click="initiatingContract">-->
<!--                    <div>-->
<!--                        <p>发起合同</p>-->
<!--                        <span>企业现有的合同</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="initiate" @click="stencil">-->
<!--                    <div>-->
<!--                        <p>发起模板</p>-->
<!--                        <span>已创建的模板</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
        <div class="contractListBox">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <!--                待我处理-->
                <el-tab-pane label="待我处理" name="fourth">
                    <waitMe v-if="activeName === 'fourth'"></waitMe>
                </el-tab-pane>
                <!--                待他人处理-->
                <el-tab-pane label="待他人处理" name="fifth">
                    <treatOthers v-if="activeName === 'fifth'"></treatOthers>
                </el-tab-pane>
<!--                我发起的-->
<!--                <el-tab-pane label="我发起的" name="second">-->
<!--                    <initiate v-if="activeName === 'second'"></initiate>-->
<!--                </el-tab-pane>-->
<!--                我收到的-->
<!--                <el-tab-pane label="我收到的" name="third">-->
<!--                    <received v-if="activeName === 'third'"></received>-->
<!--                </el-tab-pane>-->
<!--                已完成-->
                <el-tab-pane label="已完成" name="sixth">
                    <complete v-if="activeName === 'sixth'"></complete>
                </el-tab-pane>
<!--                已过期-->
                <el-tab-pane label="已过期" name="seventh">
                    <overdue v-if="activeName === 'seventh'"></overdue>
                </el-tab-pane>
<!--                已拒签-->
                <el-tab-pane label="已拒签" name="eighth">
                    <invalid v-if="activeName === 'eighth'"></invalid>
                </el-tab-pane>
<!--                已作废-->
                <el-tab-pane label="已作废" name="ninth">
                    <revocation v-if="activeName === 'ninth'"></revocation>
                </el-tab-pane>
<!--                发起失败-->
                <el-tab-pane label="发起失败" name="tenth">
                    <failurePage v-if="activeName === 'tenth'"></failurePage>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import initiate from "./components/initiate";
    import received from "./components/received";
    import waitMe from "./components/waitMe"
    import treatOthers from "./components/treatOthers";
    import complete from  "./components/complete"
    import overdue from  "./components/overdue"
    import invalid from "./components/invalid"
    import revocation from  "./components/revocation"
    import failurePage from './components/failurePage';
    export default {
        name: "contract",
        data() {
            return {
                activeName: 'fourth'
            };
        },
        components:{
            initiate,      //我发起的
            received,      //我收到的
            waitMe,        //待我处理
            treatOthers,   //待他人处理
            complete,      //已完成
            overdue,       //已过期
            invalid,       //已拒签
            revocation,     //已作废
            failurePage,    //发起失败
        },
        methods:{
            // //发起合同
            // initiatingContract(){
            //     this.$router.push('/initiatingContract')
            // },
            // //发起模板
            // stencil(){
            //     this.$router.push('/InitiateTemplate')
            // },
            updateType () {
                let type = this.$route.query.type
                // 判断type的值，更改activeName的值
                //待我处理
                if (type === 'fourth') {
                    sessionStorage.setItem('currentTab', 'fourth')
                    return  this.activeName = 'fourth'
                //    我发起的
                } else if (type === 'second') {
                    sessionStorage.setItem('currentTab', 'second')
                    return this.activeName = 'second'
                //    我收到的
                } else if (type === 'third') {
                    sessionStorage.setItem('currentTab', 'third')
                    return  this.activeName = 'third'
                //    待他人处理
                } else if (type === 'fifth') {
                    sessionStorage.setItem('currentTab', 'fifth')
                    return  this.activeName = 'fifth'
                //    已完成
                } else if (type === 'sixth') {
                    sessionStorage.setItem('currentTab', 'sixth')
                    return  this.activeName = 'sixth'
                //    已过期
                } else if (type === 'seventh') {
                    sessionStorage.setItem('currentTab', 'seventh')
                    return  this.activeName = 'seventh'
                //    已拒签
                } else if (type === 'eighth') {
                    sessionStorage.setItem('currentTab', 'eighth')
                    return  this.activeName = 'eighth'
                //    已作废
                } else if (type === 'ninth') {
                    sessionStorage.setItem('currentTab', 'ninth')
                    return  this.activeName = 'ninth'
                //    发起失败
                } else if (type === 'tenth') {
                    sessionStorage.setItem('currentTab', 'tenth')
                    return  this.activeName = 'tenth'
                }
            },
            handleClick(tab, event){
                sessionStorage.setItem('currentTab', tab.name)
            }
        },
        created() {
            this.updateType()
            let name = sessionStorage.getItem('currentTab')
            // 判断是否存在currentTab，即tab页之前是否被点击切换到别的页面
            if(name){
                this.activeName = name
            }
        },
    }
</script>

<style scoped>
    .initiateBox{
        display: flex;
        align-items: center;
        width: 100%;
        height: 150px;
        background-color: #fff;
        margin-bottom: 10px;
        /*border-radius: 10px;*/
    }
    .contract{
        display: flex;
        width: 35%;
        justify-content: space-evenly;
    }
    .initiate{
        cursor:pointer;
        width: 170px;
        height: 90px;
        text-align: center;
        border-radius: 20px;
        color: #fff;
        background-image: linear-gradient(to right, #2245b4 , #3f62f4);
    }
    .initiate>div{
        display: flex;
        height: 100%;
        justify-content: center;
        align-content: center;
        flex-direction: column
        /*font-size: 28px;*/
    }
    .initiate p{
        font-size: 26px;
        font-weight: 600;
    }
    .initiate span{
        font-size: 14px;
        margin-top: 10px;
    }
    /*合同列表*/
    .contractListBox{
        width: 100%;
        /*height: 600px;*/
        background-color: #fff;
        margin: 0px auto;
        /*border-radius: 10px;*/
    }
    ::v-deep .el-tabs--top{
        width: 95%;
        margin: 0px auto;
        padding: 20px 0px;
    }
    ::v-deep.el-tabs__item{
        padding: 0px 35px;
    }
    ::v-deep .is-active{
        color: #3d62f6;
    }
    ::v-deep .el-tabs__active-bar{
        background-color: #3d62f6;
    }
</style>
